// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OYdJ","newExpiryDate":"styles_newExpiryDate__wUGW-","footer":"styles_footer__1Dp_T"};